export default "__VITE_ASSET__B00ohs_r__"